import styled, { css } from "styled-components"
import devices from "styles/devices"
import TickBlack from "url:assets/images/icons/TickBlack.svg"
import IconTick from "url:assets/images/icons/Icon_Tick.svg"
import ListItem from "url:assets/images/icons/ListItem.svg"

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 848px;
  margin-top: 16px;

  @media screen and ${devices.bp_xs} {
    margin: 16px 16px 0 16px;
    gap: 16px;
  }

  @media screen and ${devices.bp_xl} {
    min-width: 768px;
    margin: 8.5em 12.5em 0 6.25em;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ffebdc;
  text-align: center;
  border-radius: 24px;
  padding: 32px 24px;
`

export const Header = styled.h1`
  font-size: 32px;
  font-weight: 700;
  max-width: 380px;
  @media screen and ${devices.bp_xl} {
    margin-top: 3em;
  }
`

export const SubHeader = styled.p`
  line-height: 1.5em;
  z-index: 1000;
  margin: 16px 0;
  text-align: center;
  font-size: 14px;
  max-width: 380px;
  padding: 0 32px;
  @media screen and ${devices.bp_xl} {
    &:last-of-type {
      margin-bottom: 128px;
    }
  }
`

export const EmptySubHeader = styled.div`
  line-height: 25.2px;
  z-index: 1000;
  margin: 32px 0;
  text-align: center;
  font-size: 14px;
  max-width: 380px;
  padding: 0 32px;
  display: flex;
  font-weight: 500;
  flex-direction: column;
  gap: 48px;
  @media screen and ${devices.bp_xl} {
    margin-bottom: 128px;
  }
`

export const PersonImage = styled.img`
  display: none;

  @media ${devices.bp_xl} {
    width: 256px;
    display: block;
    position: absolute;
    top: -221px;
    left: 0;
  }
`

export const DogImage = styled.img`
  display: none;

  @media ${devices.bp_xl} {
    width: 196px;
    display: block;
    position: absolute;
    top: -171px;
    right: 0;
  }
`

export const SummaryContainer = styled.div`
  position: relative;
  display: none;
  flex-direction: column;
  width: 100%;
  justify-content: left;
  background: #000928;
  border-radius: 16px;
  text-align: left;
  padding: 32px;
  color: #fff;
  gap: 48px;

  @media screen and ${devices.bp_xl} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`

export const SummaryImagesContainer = styled.div`
  position: relative;
  bottom: -8px;
  width: 100%;
`

export const SummaryLendersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 5;

  @media screen and ${devices.bp_xl} {
    flex-direction: row;
  }
`

export const SummaryIcon = styled.div`
  margin-bottom: 16px;
`

export const SummaryInfo = styled.div`
  font-weight: 600;
  font-size: 20px;
`

export const SummaryDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  color: #eef0f8;
  gap: 24px;
  flex: 3;
`

export const SummaryDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  gap: 8px;
`
export const SummaryDetailsTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
`

export const SummaryDetailsDigits = styled.div`
  font-weight: 600;
  font-size: 24px;
`

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  @media screen and ${devices.bp_xl} {
    width: 34em;
  }
`

export const DetailsSection = styled.div`
  background: #fff;
  border-radius: 24px;
`

export const RateCheckPromiseTitle = styled.h2`
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
`

export const SectionTitle = styled.div`
  padding: 24px 32px 8px 32px;

  & > h2 {
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
  }

  & > span {
    font-weight: 600;
    font-size: 24px;
  }

  & > p {
    font-weight: 500;
    font-size: 14px;
    color: rgba(59, 66, 88, 1);
    line-height: 24px;
  }

  @media screen and ${devices.bp_xl} {
    padding: 24px 32px 8px 32px;
  }
`

export const KeyDetailsList = styled.ul`
  padding: 24px;
  background: rgba(7, 62, 217, 0.05);
  background-opacity: 5%;
  border-radius: 16px;
  margin: 8px;
`

export const AdditionalNotes = styled.p`
  margin: 8px 32px 24px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
`

export const KeyDetailsListItem = styled.li`
  display: flex;
  justify-content: space-between;
  list-style-type: none;
  border-bottom: 1px solid rgba(181, 190, 220, 1);
  padding-bottom: 16px;
  margin-top: 16px;

  &:first-of-type {
    margin-top: 0;
  }

  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0px;
  }

  & > span:first-of-type {
    font-weight: 500;
    font-size: 16px;
    flex: 1;
    text-align: left;
    line-height: 28px;
  }

  & > span {
    font-weight: 600;
    font-size: 16px;
    text-align: right;
    flex: 1;
    line-height: 28px;
  }
`

export const KeyDetailsBoldText = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  align-self: center;
`

const SubText = styled.p`
  line-height: 18px;
  margin-bottom: 0px;
  color: #000928;

  @media screen and ${devices.bp_xl} {
    margin-top: 8px;
  }
`

export const SubTextSmall = styled(SubText)`
  font-weight: 500;
  margin-top: 8px;
  font-size: 12px;
`

export const SubTextMedium = styled(SubText)`
  font-weight: normal;
  margin-top: 12px;
  font-size: 16px;
`

export const KeyDetailsWithSubText_SharedStyles = css`
  display: flex;
  gap: 16px;

  & > span:first-of-type {
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
  }
`

export const KeyDetailsWithSubText = styled.span<{ direction?: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  & > div:first-of-type {
    ${KeyDetailsWithSubText_SharedStyles}
    justify-content: space-between;
  }

  & > div:last-of-type {
    ${KeyDetailsWithSubText_SharedStyles}
    justify-content: ${({ direction }) => (direction === "right" ? "flex-end" : "space-between")};
  }
`

export const FixedPeriodContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;

  & > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    font-size: 16px;
    flex: 1;
    text-align: left;
    line-height: 28px;

    & > span:first-of-type {
      font-weight: 500;
    }
  }
`

export const BrokerFeeContainer = styled.div`
  background: #073ed9;
  border-radius: 16px;
  color: white;
  display: flex;
  gap: 8px;
  flex-direction: column;
  padding: 24px;

  & > div {
    display: flex;
    justify-content: space-between;

    & > h3 {
      font-weight: 600;
      font-size: 16px;
      line-height: 28.8px;
    }
  }
  & > p {
    padding: 0;
    margin: 0;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
  }
`

export const ExtraPill = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  padding: 12px 8px;

  & > span:first-of-type {
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(251, 187, 91, 1);
    border-radius: 100%;
    width: 24px;
    height: 24px;

    ::after {
      content: url(${TickBlack});
      stroke: black;
      transform: scale(1);
      position: relative;
      top: 2px;
    }
  }

  & > span {
    font-weight: 600;
    font-size: 16px;
  }
`

export const ExtrasList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 12px;
  background: rgba(255, 247, 235, 1);
  border-radius: 16px;
  margin: 8px;

  @media screen and ${devices.bp_sm} {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 32px;
  }
`

export const DocumentsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 8px;
`

export const Document = styled.li`
  display: flex;
  flex-direction: column;
  align-items: end;
  background: rgba(7, 62, 217, 0.05);
  border-radius: 16px;
  list-style-type: none;
  padding: 24px;

  @media screen and ${devices.bp_sm} {
    align-items: initial;
  }

  @media screen and ${devices.bp_xl} {
    align-items: end;
    flex-direction: row;
  }
`

export const DocumentDetails = styled.div`
  display: flex;
  flex-direction: column;

  & > span {
    font-weight: 600;
    font-size: 18px;
  }

  & > p {
    font-weight: 500;
    font-size: 14px;
    color: rgba(59, 66, 88, 1);
    line-height: 24px;
    flex: 1;
    margin: 16px 0 0 0;

    @media screen and ${devices.bp_xl} {
      align-items: center;
      flex: 8;
    }
  }

  @media screen and ${devices.bp_xl} {
    margin-right: 64px;
  }
`

export const DownloadLoadingSpinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 8px 8px 0;
  margin-top: 16px;
  width: 100%;
  font-weight: 600;
  font-size: 16px;
  flex: 1;

  @media screen and ${devices.bp_xl} {
    flex: 2;
    margin-top: 0px;
    padding: 0 64px;
    height: 56px;
  }
`

export const DocumentDownload = styled.button`
  cursor: pointer;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 8px 8px 0;
  margin-top: 16px;
  width: 100%;
  border-radius: 8px;
  border: 2px solid black;
  font-weight: 600;
  font-size: 16px;
  flex: 1;

  @media screen and ${devices.bp_xl} {
    flex: 2;
    margin-top: 0px;
    padding: 0 24px 0 16px;
    height: 56px;
  }

  ::before {
    content: url(${ListItem});
    fill: black;
    color: black;
    transform: scale(1);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
    padding: 4px 2px 0px 0px;
    margin: 8px;
    border-right: 2px solid black;
  }
`

export const DocumentDownloadLink = styled.a`
  cursor: pointer;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 8px 8px 0;
  margin-top: 16px;
  width: 100%;
  border-radius: 8px;
  border: 2px solid black;
  font-weight: 600;
  font-size: 16px;
  flex: 1;

  @media screen and ${devices.bp_xl} {
    flex: 2;
    margin-top: 0px;
    padding: 0 24px 0 16px;
    height: 56px;
  }

  ::before {
    content: url(${ListItem});
    fill: black;
    color: black;
    transform: scale(1);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
    padding: 4px 2px 0px 0px;
    margin: 8px;
    border-right: 2px solid black;
  }
`

export const Ready = styled.div`
  background: #ffebdc;
  border-radius: 24px;
  padding: 8px;
`

export const ReadyDetailsInfo = styled.div`
  padding: 24px;

  & > span {
    font-weight: 600;
    font-size: 24px;
  }

  & > p {
    font-weight: 500;
    font-size: 14px;
    color: rgba(59, 66, 88, 1);
    line-height: 24px;
  }
`

export const ReadyDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;

  & > div {
    color: #3b4258;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
  }
`

export const ReadyDetailsAcceptance = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;

  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-width: 300px;
    gap: 8px;

    @media screen and ${devices.bp_sm} {
      width: auto;
    }
  }

  @media screen and ${devices.bp_sm} {
    flex-direction: row;
  }
`

export const ReadyText = styled.p`
  font-weight: 500;
  font-size: 14px;
  color: rgba(59, 66, 88, 1);
  line-height: 24px;
  flex: 1;
  margin: 0;

  @media screen and ${devices.bp_sm} {
    align-items: center;
  }
`

export const UploadDocumentsContainer = styled.div`
  padding: 32px;
  border-radius: 16px;
  background: #fff;

  & > span {
    font-weight: 600;
    font-size: 18px;
    text-align: center;
  }

  & > div {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    & > span {
      flex: 8;
    }

    @media screen and ${devices.bp_sm} {
      flex-direction: row;
    }
  }
`

export const DocumentsUploadLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  color: #fff;
  padding: 8px 16px 0 16px;
  width: 100%;
  height: 54px;
  border: none;
  background: rgba(7, 62, 217, 1);
  box-shadow: 0px 8px 0px 0px rgba(0, 27, 190, 1);
  min-width: 234px;
  text-decoration: none;

  @media screen and ${devices.bp_sm} {
    width: auto;
  }

  &:hover {
    opacity: 90%;
  }
`

export const Disclaimer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: center;
  padding: 32px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
`

export const RecommendationAccepted = styled.div`
  color: #398056;
  background: #eef5f3;
  padding: 8px 16px 0px 16px;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 54px;
  border-radius: 8px;

  ::before {
    content: url(${IconTick});
  }
`

export const AcceptButton = styled.button`
  border-radius: 8px;
  cursor: pointer;
  color: #fff;
  padding: 8px 16px 0 16px;
  width: 100%;
  height: 54px;
  border: none;
  background: rgba(7, 62, 217, 1);
  box-shadow: 0px 8px 0px 0px rgba(0, 27, 190, 1);

  &:hover {
    opacity: 90%;
  }
`

export const OverpaymentAreaContainer = styled.div`
  & > h2 {
    padding: 16px 32px 8px 32px;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
  }
`

export const DealEndInfoContainer = styled.div`
  background: #fff;
  border-radius: 24px;

  & > p {
    padding: 24px 32px 24px 8px;
    font-weight: 500;
    font-size: 14px;
    color: rgba(59, 66, 88, 1);
    line-height: 24px;
    margin: 0;
  }
`

export const KeyDetailsListItemSubText = styled.span`
  display: flex;
  font-size: 12px;
  line-height: 18px;
  font-weight: normal;
  color: #000928;
  width: 100%;
  text-align: right;
`

export const MortgageExpertContainer = styled.div`
  display: flex;
  background: #fff;
  border-radius: 24px;
  padding: 32px;

  & > img {
    display: none;
    width: 56px;
    height: 56px;
    margin-right: 16px;

    @media screen and ${devices.bp_xs} {
      display: block;
    }
  }
`

export const MortgageExpertContactDetails = styled.div`
  display: flex;
  flex-direction: column;

  & > p {
    font-weight: 400;
    font-size: 16px;
    margin: 8px 0;
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media screen and ${devices.bp_sm} {
      flex-direction: row;
      gap: 32px;
    }
  }
`

export const RateChecker = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 24px;
  margin-top: 16px;
  padding: 8px;
  @media screen and ${devices.bp_sm} {
    flex-direction: row;
  }
`
export const RateCheckerDetails = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 32px 32px 24px;
  gap: 16px;
  & > span {
    font-weight: 600;
    font-size: 18px;
  }
  & > p {
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    color: rgba(59, 66, 88, 1);
    line-height: 24px;
  }
  @media screen and ${devices.bp_xl} {
    padding: 32px 32px 8px 24px;
  }
`
export const MojoLogo = styled.img`
  height: 24px;
  width: 84px;
`
export const RateCheckerTitle = styled.div`
  display: flex;
  align-items: end;
  margin-bottom: 16px;
  & > span {
    font-size: 16px;
    margin-left: 16px;
  }
`

export const RateCheckerPromiseImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  @media screen and ${devices.bp_sm} {
    max-width: 280px;
    max-height: 280px;
  }
`

export const RateCheckerImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  @media screen and ${devices.bp_sm} {
    max-width: 360px;
    max-height: 360px;
  }
`

export const RateCheckerFAQLink = styled.a`
  color: #073ed9;
`
